import Icon from '@/components/ui/AppIcon';

interface ContactHeroProps {
  className?: string;
}

const ContactHero = ({ className = '' }: ContactHeroProps) => {
  return (
    <section
      className={`relative bg-white py-20 lg:py-28 ${className}`}
      style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, #ececec 1px, transparent 0)',
        backgroundSize: '24px 24px',
      }}
    >
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-[44px] md:text-[56px] lg:text-[64px] font-bold leading-[0.98] tracking-[-0.035em] text-foreground mb-6">
          Let&apos;s <span className="text-plum">connect.</span>
        </h1>

        <p className="text-[18px] leading-[1.55] text-muted-foreground max-w-[640px] mx-auto mb-10">
          Multiple ways to reach us. Whether you&apos;re a homeowner needing a fast sale or an
          investor seeking opportunities, we&apos;re here to help.
        </p>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-[13px] text-muted-foreground">
          <div className="flex items-center gap-2">
            <Icon name="ClockIcon" size={16} className="text-plum" />
            <span>Fast response</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="PhoneIcon" size={16} className="text-plum" />
            <span>Direct line to acquisitions</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="CheckCircleIcon" size={16} className="text-plum" />
            <span>Licensed &amp; insured</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
